import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 20000
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response && error.message?.includes('Network Error')) {
      error.response = { data: { error: 'Falha de rede ou API indisponível no momento.' } }
    }
    return Promise.reject(error)
  }
)

export default api
